import React from 'react';
import { makeStyles } from '@material-ui/core';
import { CaretDown } from '@carbon/icons-react';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import useViewerApiContext from '../context/useViewerApiContext';

const MobileViewerDimensionsButton: React.FunctionComponent = () => {
  const { dimensionsButtonContainer } = useStyles();
  const { onOpenDimensions } = useViewerApiContext();

  return (
    <div className={dimensionsButtonContainer} onClick={onOpenDimensions}>
      <CustomizedTypography
        variant="body2"
        fontWeight="500"
        color="textPrimary"
      >
        치수정보
      </CustomizedTypography>
      <CustomizedTypography variant="subtitle2" color="textSecondary">
        Dimensions
      </CustomizedTypography>

      <CaretDown className="end-icon" size={16} color={colorSet.gray700} />
    </div>
  );
};

export default MobileViewerDimensionsButton;

const useStyles = makeStyles(() => ({
  dimensionsButtonContainer: {
    height: '52px',
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    gap: '6px',
    '& .end-icon': {
      marginLeft: 'auto'
    },
    '&:hover': {
      cursor: 'pointer'
    }
  }
}));
